import { Avatar, Box, Grid, TextField, Typography, Button, FormControl, Select, MenuItem, InputAdornment, IconButton } from '@mui/material';
import SwitchComponent from '../../../components/switch';
import { useFormDriverController } from '../controller/form';
import { GenderEnum } from '../../../enums/genderEnum';
import { convertGenderToString } from '../../../utils/convertGender';
import { DriverModel } from '../../../models/driver';
import { DriverEnum } from '../../../enums/driverEnum';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { convertRoleDriverToString } from '../../../utils/convertRole';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { TEXT_TITLE_COLOR } from '../../../constants/colors';
import { useTranslation } from 'react-i18next';

interface props {
  onClose: VoidFunction;
  selectedProfileData: DriverModel
  onFetchData: Function
  selected: Function
}

const DriverForm = ({ onClose, selectedProfileData, onFetchData, selected }: props) => {
  const controller = useFormDriverController({ selectedProfileData, onClose, onFetchData, selected });
  const { t } = useTranslation('global');
  return (
    <Box>
      <IconButton onClick={() => { onClose(); controller.handleReset() }} sx={{ mb: 2 }}>
        <KeyboardBackspaceIcon />
      </IconButton>
      <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>{selectedProfileData ? t('driverUser_page.Update Driver User') : t('driverUser_page.Create Driver User')}</Typography>
      <form onSubmit={(e) => controller.handleOpenAddRiderForm(e)}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                p: 8,
                boxShadow:
                  '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                borderRadius: '10px'
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <label htmlFor="image-input-rider">
                  <Avatar
                    src={controller.imageToShow}
                    alt=""
                    style={{ cursor: 'pointer', width: 150, height: 150, objectFit: 'contain' }}
                  />
                </label>
                <input
                  type="file"
                  id="image-input-rider"
                  onClick={(e: any) => {
                    e.target.value = '';
                  }}
                  onChange={controller.handleSelectedImage}
                  style={{ display: 'none' }}
                />
              </Box>
              <Box mt={2}>
                <Typography textAlign="center">Allowd *.jpeg,*.jpg,*.png</Typography>
                <Typography textAlign="center">Max size of 3.1 MB</Typography>
              </Box>
            </Box>
            {
              selectedProfileData && <Box
                sx={{ display: 'flex', justifyContent: 'center', mt: 1, alignItems: 'center', gap: 2 }}
              >
                <Typography>
                  <span style={{ color: 'green' }}>{t("driverUser_page.Active")}</span> / <span style={{ color: 'red' }}>{t("driverUser_page.InActive")}</span>
                </Typography>
                <SwitchComponent value={controller.banUser} onChange={controller.handleBanUser} />
              </Box>
            }

          </Grid>
          <Grid item xs={12} sm={8}>
            <Box
              sx={{
                p: 4,
                boxShadow:
                  '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                borderRadius: '10px'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Full Name")}</Typography>
                  <TextField
                    fullWidth
                    required
                    inputRef={controller.fullName}
                    placeholder='ປ້ອນຊື່ເຕັມ'
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Phone Number")}</Typography>
                  <TextField
                    fullWidth
                    required
                    inputRef={controller.phoneNumber}
                    placeholder='ປ້ອນເບີໂທລະສັບ'
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Second Phone Number")}</Typography>
                  <TextField
                    fullWidth
                    required
                    inputRef={controller.secondPhone}
                    placeholder='ປ້ອນເບີໂທລະສັບສຳຮອງ'
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Area")}</Typography>
                  <TextField
                    fullWidth
                    required
                    inputRef={controller.area}
                    placeholder='ປ້ອນເຂດຄົນຂັບ'
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Date of Birth")}</Typography>
                  <TextField
                    fullWidth
                    required
                    type='date'
                    inputRef={controller.dateOfBirth}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Gender")}</Typography>
                  <FormControl fullWidth margin='normal'>
                    <Select value={controller.selectedGender} onChange={controller.handleSelectedGender}>
                      {
                        Object.values(GenderEnum).map((gender: GenderEnum) => (
                          <MenuItem key={gender} value={gender}>
                            {convertGenderToString(gender)}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.User name")}</Typography>
                  <TextField
                    fullWidth
                    required
                    inputRef={controller.username}
                    placeholder='ປ້ອນຊື່ຜູ້ໃຊ້ງານ'
                    margin="normal"
                    inputProps={
                      selectedProfileData ? { readOnly: true } : {}
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Role")}</Typography>
                  <FormControl fullWidth margin='normal'>
                    <Select value={controller.selectedDriverType} onChange={controller.handleSelectedDriverType}>
                      {
                        Object.values(DriverEnum)
                          .filter((type) => type !== DriverEnum.ALL)
                          .map((type: DriverEnum) => (
                            <MenuItem key={type} value={type}>
                              {t("driverUser_page." + type)}
                            </MenuItem>
                          ))
                      }
                    </Select>
                  </FormControl>
                </Grid>
                {
                  selectedProfileData ? <Box></Box> : <>
                    <Grid item xs={12} sm={6}>
                      <Typography>{t("driverUser_page.password")}</Typography>
                      <TextField
                        fullWidth
                        type={controller.showPassword ? 'text' : 'password'}
                        required
                        inputRef={controller.password}
                        placeholder='ປ້ອນລະຫັດຜ່ານ'
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                edge="end"
                                onClick={controller.handleShowPassword}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                {controller.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography>{t("driverUser_page.Confirm password")}</Typography>
                      <TextField
                        fullWidth
                        type={controller.showConfirmPassword ? 'text' : 'password'}
                        required
                        inputRef={controller.confirmPassword}
                        placeholder='ຢືນຢັນລະຫັດຜ່ານ'
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                edge="end"
                                onClick={controller.handleShowConfirmPassword}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                {controller.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                  </>
                }

                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Order limit")}</Typography>
                  <TextField
                    fullWidth
                    required
                    inputRef={controller.order}
                    placeholder='ປ້ອນການຈຳກັດການຮັບອໍເດີ້'
                    margin='normal'
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("driverUser_page.Money limit")}</Typography>
                  <TextField
                    fullWidth
                    required
                    inputRef={controller.money}
                    placeholder='ປ້ອນການຈຳກັດຈຳນວນເງີນ'
                    margin='normal'
                  />
                </Grid>
              </Grid>
              <Box>
                {controller.errorMessage && <Typography color='error'>{controller.errorMessage}</Typography>}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, height: 40 }}>
                <Button type='submit' variant="contained" sx={{ textTransform: 'none', width: 150, background: '#11A2F1', borderRadius: '10px' }}>
                  {selectedProfileData ? t('driverUser_page.Edit Driver/Rider') : t('driverUser_page.Add Driver/Rider')}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <ConfirmDialog
          open={controller.openConfirm}
          title={`${selectedProfileData ? t("Do you want to update this data ?") : t("Do you want to create this data ?")}`}
          loading={controller.loadingConfirmForm}
          onCancel={controller.handleCloseAddRiderForm}
          onConfirm={() => controller.handleSubmit()}
        />
      </form>
    </Box>
  );
};
export default DriverForm;
